import Vue from 'vue';
import { studentEvaluationStatusColor } from '@/enums/student-evaluation-status-color';
import { uiColors } from '@/enums/ui-color';

Vue.filter(
  'studentEvalutationStatusColor',
  (statusId) => studentEvaluationStatusColor[statusId] ?? uiColors.Orange
);
